import { createFeature, createReducer, on } from '@ngrx/store';
import { TaxIdentificationNumberDetailsActions } from '../../actions/tax-identification-number-details/tax-identification-number-details.actions';
import { AddOrganizationActions } from '@store/actions/add-organization/add-organization.actions';
import { OrganizationTin } from '@models/organizationTin.model';

export const taxIdentificationNumberDetailsFeatureKey = 'taxIdentificationNumberDetails';

export interface State {
  tins: OrganizationTin[],
  isSaveDisabled: boolean,
  search: string,
  page: number,
  itemsPerPage: number,
  totalItems: number
}

export const initialState: State = {
  tins: [],
  isSaveDisabled: false,
  search: "",
  page: 0,
  itemsPerPage: 5,
  totalItems: 0
};

export const reducer = createReducer(
  initialState,
  on(TaxIdentificationNumberDetailsActions.itemsPerPageChanged, (state, action) => ({
    ...state,
    itemsPerPage: action.items
  })),
  on(TaxIdentificationNumberDetailsActions.addTINSave, (state, action) => ({
    ...state,
    isSaveDisabled: true
  })),
  on(TaxIdentificationNumberDetailsActions.addTINSuccess, (state, action) => ({
    ...state,
    tins: [...state.tins, action.data],
    isSaveDisabled: false
  })),
  on(TaxIdentificationNumberDetailsActions.addTINFailure, (state, action) => ({
    ...state,
    isSaveDisabled: false
  })),
  on(TaxIdentificationNumberDetailsActions.editTIN, (state, action) => ({
    ...state,
    isSaveDisabled: true
  })),
  on(TaxIdentificationNumberDetailsActions.editTINSuccess, (state, action) => {
    const updatedTins = state.tins.map((tin) =>
      action.data.id === tin.id ? action.data : tin
    );
    return {
      ...state,
      tins: updatedTins,
      isSaveDisabled: false,
    };
  }),
  on(TaxIdentificationNumberDetailsActions.editTINFailure, (state, action) => ({
    ...state,
    isSaveDisabled: false
  })),
  on(TaxIdentificationNumberDetailsActions.deleteTINSuccess, (state, action) => {
    const updatedTins = state.tins.filter((tin) => tin.id != action.id );
    return {
      ...state,
      tins: updatedTins,
    };
  }),
  on(TaxIdentificationNumberDetailsActions.pageNumberChanged, (state, action) => ({
    ...state,
    page: action.page
  })),

  on(AddOrganizationActions.getOrganizationDetailsSuccess, (state, action) => ({
    ...state,
    tins: action.details.organizationTins ?? []
  })),

  on(AddOrganizationActions.getOrganizationDetailsFailure, (state) => ({
    ...state,
    tins: []
  })),

  on(TaxIdentificationNumberDetailsActions.getTINDetailsFailure, (state, action) => ({
    ...state,
    tins: [],
    totalItems: 0
  })),
);

export const taxIdentificationNumberDetailsFeature = createFeature({
  name: taxIdentificationNumberDetailsFeatureKey,
  reducer,
});

